import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { BackToOverview } from '../../../components/ImageGalleryLayer/components/BackToOverview/index.js';
import { GalleryTitle } from '../../../components/ImageGalleryLayer/components/GalleryTitle.js';
import { Stack } from '../../../primitives/index.js';
const Component = forwardRef(({
  hotel,
  backToOverviewLabel,
  rating = 0,
  verified,
  handleOverview,
  isOverview,
  ...restProps
}, ref) => _jsxs(Stack, {
  direction: "row",
  spacing: "none",
  ...restProps,
  ref: ref,
  children: [!isOverview && _jsx(BackToOverview, {
    label: backToOverviewLabel,
    handleOverview: handleOverview
  }), _jsx(GalleryTitle, {
    hotel: hotel,
    rating: rating,
    verified: verified,
    isOverview: isOverview
  })]
}));
export const Header = /*#__PURE__*/_styled(Component, process.env.NODE_ENV === "production" ? {
  target: "e1k8zy8j0"
} : {
  target: "e1k8zy8j0",
  label: "Header"
})(process.env.NODE_ENV === "production" ? {
  name: "1ud9i0q",
  styles: "padding:8px 0"
} : {
  name: "1ud9i0q",
  styles: "padding:8px 0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPd0MiLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBCYWNrVG9PdmVydmlldyB9IGZyb20gJy4uLy4uLy4uL2NvbXBvbmVudHMvSW1hZ2VHYWxsZXJ5TGF5ZXIvY29tcG9uZW50cy9CYWNrVG9PdmVydmlldy9pbmRleC5qcyc7XG5pbXBvcnQgeyBHYWxsZXJ5VGl0bGUgfSBmcm9tICcuLi8uLi8uLi9jb21wb25lbnRzL0ltYWdlR2FsbGVyeUxheWVyL2NvbXBvbmVudHMvR2FsbGVyeVRpdGxlLmpzJztcbmltcG9ydCB7IFN0YWNrIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9pbmRleC5qcyc7XG5jb25zdCBDb21wb25lbnQgPSBmb3J3YXJkUmVmKCh7IGhvdGVsLCBiYWNrVG9PdmVydmlld0xhYmVsLCByYXRpbmcgPSAwLCB2ZXJpZmllZCwgaGFuZGxlT3ZlcnZpZXcsIGlzT3ZlcnZpZXcsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IChfanN4cyhTdGFjaywgeyBkaXJlY3Rpb246IFwicm93XCIsIHNwYWNpbmc6IFwibm9uZVwiLCAuLi5yZXN0UHJvcHMsIHJlZjogcmVmLCBjaGlsZHJlbjogWyFpc092ZXJ2aWV3ICYmIChfanN4KEJhY2tUb092ZXJ2aWV3LCB7IGxhYmVsOiBiYWNrVG9PdmVydmlld0xhYmVsLCBoYW5kbGVPdmVydmlldzogaGFuZGxlT3ZlcnZpZXcgfSkpLCBfanN4KEdhbGxlcnlUaXRsZSwgeyBob3RlbDogaG90ZWwsIHJhdGluZzogcmF0aW5nLCB2ZXJpZmllZDogdmVyaWZpZWQsIGlzT3ZlcnZpZXc6IGlzT3ZlcnZpZXcgfSldIH0pKSk7XG5leHBvcnQgY29uc3QgSGVhZGVyID0gc3R5bGVkKENvbXBvbmVudCkgYFxuICBwYWRkaW5nOiA4cHggMDtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1IZWFkZXIuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});